// extracted by mini-css-extract-plugin
module.exports = {"modalButtonWrapper":"missingSomethingModalButton_modalButtonWrapper__WvFSv","missingButton":"missingSomethingModalButton_missingButton__1XxF7"};